<div class="containerBanner" style="overflow: hidden">
  <div class="menu-container">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        @if(selectedFilter === WORKSTATION_FILTER.ALL){
        <h1 class="m-0">
          Workstations <span>({{ this.totalWorkstation }})</span>
        </h1>
        } @if(selectedFilter === WORKSTATION_FILTER.ASSIGNED || (selectedFilter !== WORKSTATION_FILTER.ALL &&
        selectedFilter
        !== WORKSTATION_FILTER.ASSIGNED_MINE)){
        <h1 class="m-0">
          Assigned Workstations <span>({{ this.totalWorkstation }})</span>
        </h1>
        } @if(selectedFilter === WORKSTATION_FILTER.ASSIGNED_MINE){
        <h1 class="m-0">
          Assigned Workstations(Mine) <span>({{ this.totalWorkstation }})</span>
        </h1>
        }
      </div>
    </div>
    <div class="workstation-menu d-flex align-items-center justify-content-between"
      style="margin-bottom: 15px; margin-top: 10px">
      <div class="search-menu">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"
          class="search-icon">
          <g opacity="0.4">
            <circle cx="11.0795" cy="11.3768" r="7.62168" transform="rotate(-45 11.0795 11.3768)" stroke="#092C4C"
              stroke-width="1.72802" stroke-linecap="round" />
            <path d="M16.6416 16.9393L19.8465 20.1443" stroke="#092C4C" stroke-width="1.72802" stroke-linecap="round" />
          </g>
        </svg>
        <input type="search" placeholder="please hit enter after typing.." [(ngModel)]="searchQuery"
          (keyup.enter)="onSearchInventory()" />
        @if(searchQuery){
        <img class="search-close" style="cursor: pointer" src="../../../assets/closeIcon.png" alt=""
          (click)="clearSearch()" />}
      </div>
      <div class="btn-container d-flex align-items-center justify-content-between styled-select">
        <div class="mat-dropdown-panel sort-dropdown-panel" style="margin-right: 12px;">
          <mat-form-field>
            <mat-select [(value)]="selectedSort" (selectionChange)="onSortDropdownChange($event.value)"
              placeholder="Sort By" panelClass="sort-filter-select-panel">
              <mat-option value="newest">Newest</mat-option>
              <mat-option value="oldest">Oldest</mat-option>
              <mat-option value="ascName">A - Z</mat-option>
              <mat-option value="descName">Z - A</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="mat-dropdown-panel">
          <mat-form-field>
            <mat-select [(value)]="selectedFilter" (selectionChange)="onFilterChange($event.value)"
              placeholder="Workstations" panelClass="workstation-filter-select-panel">
              <mat-option [value]="WORKSTATION_FILTER.ALL">All Workstations</mat-option>
              <mat-option [value]="WORKSTATION_FILTER.ASSIGNED">All Assigned</mat-option>
              <mat-option [value]="WORKSTATION_FILTER.ASSIGNED_MINE">Assigned(Mine)</mat-option>
              @for (user of users; track user.id || user.value) {
              <mat-option [value]="user.id || user.value">{{ user.viewValue }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if(showWorkstationButton ){
        <div class="inv-buttons d-flex">
          <button class="d-flex align-items-center justify-content-center add-inv" type="button" data-toggle="modal"
            data-target="#addWorkstationModal" style="margin-left: 8px" (click)="resetClose()">
            <svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" viewBox="0 0 32 32"
              style="margin-right: 8px">
              <path fill="currentColor" d="M17 15V8h-2v7H8v2h7v7h2v-7h7v-2z" />
            </svg>
            Workstation
          </button>
          @if (canExportBarcodes) {
          <button class="d-flex align-items-center justify-content-center add-inv" type="button"
            style="margin-left: 15px" [disabled]="isExportingBarcodes" (click)="exportBarcodes()">
            {{ isExportingBarcodes ? 'Exporting...' : selectedVisibleWorkstationIds.length ? 'Export Barcodes (' +
            selectedVisibleWorkstationIds.length + ')' : 'Export Barcodes' }}
          </button>
          }
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Workstation Listing -->
  <div class="table-container workstation-table-container scroll-container" infiniteScroll #infiniteScroller
    [infiniteScrollDistance]="2" [infiniteScrollThrottle]="150" (scrolled)="onScroll()" [scrollWindow]="false">
    @if(!isShimmerLoading) {
    <table class="table table-striped table-hover fixed-header-table workstation-table">
      <thead>
        <tr>
          @if (canExportBarcodes) {
          <th scope="col" style="width: 40px; min-width: 40px; padding-left: 16px">
            <input type="checkbox" [checked]="allWorkstationsSelected"
              (change)="toggleAllWorkstationSelection($any($event.target).checked)" />
          </th>
          }
          <th scope="col" style="cursor: pointer; user-select: none; min-width: 250px;">

            WORKSTATION NAME

          </th>
          <th scope="col" style="min-width: 160px;">WORKSTATION ID</th>
          <th scope="col" style="min-width: 140px;">LOCATION</th>
          <th scope="col" style="min-width: 150px;">ASSIGNED TO</th>
          <th scope="col" style="min-width: 180px;">
            ASSIGNED ON
          </th>
          <th scope="col" style="min-width: 140px;">ADDED BY</th>
          <th scope="col" style="min-width: 180px;">PROCESSOR</th>
          <th scope="col" style="min-width: 130px;">RAM VALUE</th>
          <th scope="col" style="min-width: 160px;">GRAPHIC CARD</th>
          <th scope="col" style="min-width: 140px;">WINDOWS</th>
          <th scope="col" style="min-width: 130px;">LICENCED</th>
          @if (canAccessProductKey) {
          <th scope="col" style="min-width: 160px;">PRODUCT KEY</th>
          }
          <th scope="col" style="min-width: 120px; text-align: center;">MONITORS</th>
          <th scope="col" style="min-width: 180px;">MONITORS DETAILS</th>
          <th scope="col" style="min-width: 140px;">HEADPHONE</th>
          <th scope="col" style="min-width: 140px;">KEYBOARD</th>
          <th scope="col" style="min-width: 140px;">MOUSE</th>
          <th scope="col" style="min-width: 140px;">CAMERA</th>
          <th scope="col" style="min-width: 140px;">SPEAKER</th>
        </tr>
      </thead>
      <tbody>
        @for (workstations of workstation; track $index) {
        <tr>
          @if (canExportBarcodes) {
          <td style="width: 40px; min-width: 40px; padding-left: 16px; vertical-align: middle">
            <input type="checkbox" [checked]="selectedWorkstationIds.has(workstations._id)"
              (change)="toggleWorkstationSelection(workstations._id, $any($event.target).checked)" />
          </td>
          }
          <td (click)="getSingleworkstation(workstations._id)">
            <div class="d-flex align-items-center">
              <p style="margin-bottom: 0; font-size: 13px">
                {{ $index + 1 }}
              </p>
              <div class="inventory-img" data-target="#imagePreviewModal" data-toggle="modal"
                (click)="openPreviewSlider($index)">
                <img [src]="
                      workstations.image
                        ? workstations.image
                        : '../../../assets/inventories/default-inventory.png'
                    " alt="workstation" style="width: 60px; height: 60px; cursor: pointer" />
              </div>
              <div data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer"
                (click)="openWorkstationDetail($index)">
                <p>{{ workstations.name }}</p>
              </div>
            </div>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>
              {{
              workstations.workstationId
              ? workstations.workstationId
              : " - "
              }}
            </p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p class="location">
              {{ workstations.location ? workstations.location : " - " }}
            </p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>
              {{ workstations.assignedTo ? workstations.assignedTo : " - " }}
            </p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>
              {{ workstations.assignedOn ? workstations.assignedOn : " - " }}
            </p>
          </td>


          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>
              {{
              workstations.creatorName ? workstations.creatorName : " - "
              }}
            </p>
          </td>

          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>{{ workstations.processor }}</p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>{{ workstations.ramValue }}</p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>{{ workstations.graphicCard }}</p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>{{ workstations.windows }}</p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p [style.color]="workstations.licensed ? 'green' : 'red'">
              {{ workstations.licensed ? "licensed" : "not licensed" }}
            </p>
          </td>
          @if (canAccessProductKey) {
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>{{ workstations.productKey || '—' }}</p>
          </td>
          }
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer; text-align: center"
            (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p style="text-align: center">{{ workstations.monitors }}</p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>
              {{
              workstations.monitorDetails[0] !== "null"
              ? workstations.monitorDetails[0]
              : "-"
              }}
            </p>
            <p>
              {{
              workstations.monitorDetails[1] !== "null"
              ? workstations.monitorDetails[1]
              : ""
              }}
            </p>
            <p>
              {{
              workstations.monitorDetails[2] !== "null"
              ? workstations.monitorDetails[2]
              : ""
              }}
            </p>
            <p>
              {{
              workstations.monitorDetails[3] !== "null"
              ? workstations.monitorDetails[3]
              : ""
              }}
            </p>
            <p>
              {{
              workstations.monitorDetails[4] !== "null"
              ? workstations.monitorDetails[4]
              : ""
              }}
            </p>
            <p>
              {{
              workstations.monitorDetails[5] !== "null"
              ? workstations.monitorDetails[5]
              : ""
              }}
            </p>
          </td>

          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>
              {{ workstations.headPhone ? workstations.headPhone : " - " }}
            </p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>{{ workstations.keyboard ? workstations.keyboard : " - " }}</p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>{{ workstations.mouse ? workstations.mouse : " - " }}</p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>
              {{
              workstations.camera === null ||
              workstations.camera === "" ||
              workstations.camera === "null"
              ? " - "
              : workstations.camera
              }}
            </p>
          </td>
          <td data-target="#workstationDetailModal" data-toggle="modal" style="cursor: pointer" (click)="
                openWorkstationDetail($index);
                getSingleworkstation(workstations._id)
              ">
            <p>
              {{
              workstations.speakers === null ||
              workstations.speakers === "" ||
              workstations.speakers === "null"
              ? " - "
              : workstations.speakers
              }}
            </p>
          </td>
        </tr>

        }
      </tbody>
    </table>
    @if(workstation.length === 0){
    <app-no-data></app-no-data>
    } } @if(isShimmerLoading) { @for (workstations of shimmerLoadingValue;
    track workstations; let i = $index) {
    <span class="d-flex">
      <div class="shimmer-card">
        <div class="shimmerBG media"></div>
        <div class="p-32">
          <div class="shimmerBG title-line"></div>
          <div class="shimmerBG title-line end"></div>

          <div class="shimmerBG content-line m-t-24"></div>
          <div class="shimmerBG content-line"></div>
          <div class="shimmerBG content-line"></div>
          <div class="shimmerBG content-line"></div>
          <div class="shimmerBG content-line"></div>
          <div class="shimmerBG content-line end"></div>
        </div>
      </div>
    </span>
    } }
  </div>
</div>

<!-- Add New Workstation Modal -->
<div class="modal fade" id="addWorkstationModal" tabindex="-1" role="dialog" aria-labelledby="addWorkstationModalTitle"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered main-width-content" role="document">
    <div class="modal-content" style="height:660px">
      <div class="modal-header addInventory-head">
        <h5 class="modal-title" id="addWorkstationModalTitle">
          {{ isEdit ? "Edit Workstation" : " Add New Workstation" }}
        </h5>
        <button type="button" class="close inven-cls" data-dismiss="modal" aria-label="Close">
          <svg class="cross-svg" width="14" height="12" viewBox="0 0 14 14" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5518 1.64453L1.85612 12.3402" stroke="#25252B" stroke-width="2.26313" stroke-linecap="round" />
            <path d="M12.5518 12.3401L1.85612 1.64445" stroke="#25252B" stroke-width="2.26313" stroke-linecap="round" />
          </svg>
        </button>
      </div>
      <div class="modal-body addInventory-body">
        @if (currentStep !== 3) {
        <ul class="add-inv-menu">
          <li [ngClass]="{
              active: currentStep === 1,
              completed: configurationForm.valid
            }" (click)="navigateToStep(1)">
            Configuration
          </li>
          <li [ngClass]="{
              active: currentStep === 2,
              completed: currentStep > 1
            }" (click)="configurationForm.valid ? navigateToStep(2) : null">
            <svg class="mg-space" width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.5"
                d="M6.58887 3.69341C6.75553 3.78963 6.75553 4.03019 6.58887 4.12642L0.68225 7.5366C0.515584 7.63283 0.307251 7.51255 0.307251 7.3201L0.307251 0.499725C0.307251 0.307275 0.515584 0.186994 0.682251 0.283219L6.58887 3.69341Z"
                fill="#25252B" />
            </svg>
            Accessories
          </li>

          <li [ngClass]="{
              active: currentStep === 3,
              completed: currentStep > 1
            }"></li>
        </ul>
        }

        <!-- Configuration -->
        @if(currentStep === 1){
        <div class="product-info-container">
          <div class="prod-col">
            <div class="product-image-upload">
              <div class="upload-content">
                @if (selectedImages.length > 0) {
                <ng-container>
                  <img class="previewImg" [src]="previewImagesUrl[0]" alt="" />
                  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"
                    (click)="removeImage(0)" class="remove-main-img">
                    <circle cx="13.4069" cy="13.9219" r="13" fill="#353535" />
                    <path d="M10.2818 10.7974L16.5319 17.0475" stroke="white" stroke-width="1.5"
                      stroke-linecap="round" />
                    <path d="M10.2818 17.0474L16.5319 10.7972" stroke="white" stroke-width="1.5"
                      stroke-linecap="round" />
                  </svg>
                </ng-container>
                } @if (selectedImages.length === 0) {
                <ng-container>
                  <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="21.0079" cy="20.397" r="20.2278" fill="#FDCC27" />
                    <path
                      d="M16.584 27.4629C15.7892 27.4043 14.8021 27.5967 13.8483 27.3708C11.9409 26.9191 10.8115 25.6475 10.41 23.7819C10.0168 21.9497 10.6442 20.4355 12.1584 19.3061C12.3676 19.1472 12.4429 19.03 12.3759 18.7707C11.8656 16.5956 13.7563 14.6965 15.9398 15.1985C16.1824 15.257 16.2995 15.2152 16.425 14.9893C17.7134 12.6803 20.1395 11.5342 22.7329 11.986C25.1255 12.4043 27.0497 14.3702 27.4847 16.88C27.5349 17.1561 27.6269 17.2732 27.8947 17.3401C30.2789 17.9257 31.9856 20.4271 31.6844 22.8449C31.3498 25.5303 29.2416 27.4629 26.6565 27.4629C25.3598 27.4629 24.0631 27.4545 22.7664 27.4712C22.4903 27.4712 22.415 27.3876 22.415 27.1199C22.4317 25.8064 22.4234 24.5013 22.415 23.1879C22.415 22.9285 22.4736 22.8114 22.758 22.8282C23.1177 22.8533 23.4858 22.8449 23.8456 22.8282C24.3726 22.8031 24.5734 22.435 24.2722 22.0083C23.3353 20.6949 22.3815 19.3814 21.4362 18.0763C21.1601 17.6999 20.8339 17.6999 20.5578 18.0763C19.6041 19.3814 18.6587 20.6949 17.7217 22.0083C17.4206 22.435 17.613 22.8031 18.1484 22.8282C18.5249 22.8449 18.9013 22.8365 19.2778 22.8282C19.4786 22.8282 19.5873 22.8616 19.579 23.1042C19.5706 24.4679 19.5706 25.8399 19.579 27.2035C19.579 27.4461 19.4702 27.4712 19.2694 27.4712C18.4328 27.4545 17.5963 27.4629 16.584 27.4629Z"
                      fill="white" />
                  </svg>
                </ng-container>
                <h3>Upload Photo</h3>
                }
              </div>
              <input type="file" class="form-control" (change)="onSelectImage($event)" accept="image/png, image/jpeg" />
            </div>
            <p>(Recommended Ratio: 9:9)</p>
            <h4>Add Multiple Images</h4>
            <p>Max 4 Images</p>
            <div class="d-flex align-items-center justify-content-center" style="margin-top: 16px">
              @if (selectedImages.length < 5) { <div class="image-upload-container" [ngStyle]="{
                  cursor:
                    selectedImages.length === 0 ? 'not-allowed' : 'pointer'
                }" [ngStyle]="{ opacity: selectedImages.length === 0 ? 0.7 : 1 }">
                <svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" viewBox="0 0 32 32">
                  <path fill="currentColor" d="M17 15V8h-2v7H8v2h7v7h2v-7h7v-2z" />
                </svg>
                <input type="file" (change)="onSelectMultipleImages($event)" multiple accept="image/png, image/jpeg"
                  [disabled]="selectedImages.length === 0" />
            </div>
            } @for (img of previewImagesUrl.slice(1); track img; let i = $index;) {
            <ng-container>
              <div class="multiple-img">
                <img [src]="img" alt="" />
                <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"
                  (click)="removeImage(i + 1)">
                  <circle cx="13.4069" cy="13.9219" r="13" fill="#353535" />
                  <path d="M10.2818 10.7974L16.5319 17.0475" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M10.2818 17.0474L16.5319 10.7972" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
            </ng-container>
            }
          </div>
        </div>

        <div class="form-cls">
          <form [formGroup]="configurationForm" (ngSubmit)="onSubmitConfiguration()">
            <div class="product-form-grid">
              <!-- Workstation Name -->
              <div class="form-group" [ngClass]="{
                    'has-error':
                      configurationForm.get('workstationName').invalid &&
                      (configurationForm.get('workstationName').dirty ||
                        configurationForm.get('workstationName').touched ||
                        submitted)
                  }">
                <label for="workstationName" class="form-label asterisk-lbl">Workstation Name</label>
                <input type="text" id="workstationName" class="form-control" formControlName="workstationName" />
                @if(configurationForm.get('workstationName').errors?.maxlength){
                <div style="color: red">
                  Workstation Name cannot exceed 50 characters.
                </div>
                }
              </div>

              <!-- Workstation Id -->
              <div class="form-group" [ngClass]="{
                    'has-error':
                      configurationForm.get('workstationId').invalid &&
                      (configurationForm.get('workstationId').dirty ||
                        configurationForm.get('workstationId').touched ||
                        submitted)
                  }">
                <label for="workstationId" class="form-label asterisk-lbl">Workstation Id</label>
                <input type="text" id="workstationId" class="form-control" formControlName="workstationId" />
                @if(configurationForm.get('workstationId').errors?.maxlength){
                <div style="color: red">
                  Workstation Id cannot exceed 25 characters.
                </div>
                }
              </div>

              <!-- Processor -->
              <div class="form-group" [ngClass]="{
                    'has-error':
                      configurationForm.get('processor').invalid &&
                      (configurationForm.get('processor').dirty ||
                        configurationForm.get('processor').touched ||
                        submitted)
                  }">
                <label for="processor" class="form-label asterisk-lbl">Processor</label>
                <input type="text" id="processor" class="form-control" formControlName="processor" />
                @if(configurationForm.get('processor').errors?.maxlength){
                <div style="color: red">
                  processor cannot exceed 50 characters.
                </div>
                }
              </div>

              <!-- Ram Value -->
              <div class="form-group" [ngClass]="{
                    'has-error':
                      configurationForm.get('ramValue').invalid &&
                      (configurationForm.get('ramValue').dirty ||
                        configurationForm.get('ramValue').touched ||
                        submitted)
                  }">
                <label for="ramValue" class="form-label asterisk-lbl">Ram Value</label>
                <input type="text" id="ramValue" class="form-control" formControlName="ramValue" />
                @if(configurationForm.get('ramValue').errors?.maxlength){
                <div style="color: red">
                  Ram Value cannot exceed 50 characters.
                </div>
                }
              </div>

              <!-- Graphics Card -->
              <div class="form-group" [ngClass]="{
                    'has-error':
                      configurationForm.get('graphicCard').invalid &&
                      (configurationForm.get('graphicCard').dirty ||
                        configurationForm.get('graphicCard').touched ||
                        submitted)
                  }">
                <label for="graphicCard" class="form-label asterisk-lbl">Graphics Card</label>
                <input type="text" id="graphicCard" class="form-control" formControlName="graphicCard" />
                @if(configurationForm.get('graphicCard').errors?.maxlength){
                <div style="color: red">
                  graphic card cannot exceed 50 characters.
                </div>
                }
              </div>

              <!-- Windows Version -->
              <div class="form-group" [ngClass]="{
                    'has-error':
                      configurationForm.get('version').invalid &&
                      (configurationForm.get('version').dirty ||
                        configurationForm.get('version').touched ||
                        submitted)
                  }">
                <label for="version" class="form-label asterisk-lbl">Windows Version</label>
                <input type="text" id="version" class="form-control" formControlName="version" />
                @if(configurationForm.get('version').errors?.maxlength){
                <div style="color: red">
                  Window version cannot exceed 50 characters.
                </div>
                }
              </div>

              <!-- Location -->
              <div class="form-group" [ngClass]="{
                    'has-error':
                      configurationForm.get('location').invalid &&
                      (configurationForm.get('location').dirty ||
                        configurationForm.get('location').touched ||
                        submitted)
                  }">
                <label for="location" class="form-label asterisk-lbl">Location</label>
                <input type="text" id="location" class="form-control" formControlName="location" />
                @if(configurationForm.get('location').errors?.maxlength){
                <div style="color: red">
                  location cannot exceed 50 characters.
                </div>
                }
              </div>

              <!-- Assign to -->
              <div class="form-group" [ngClass]="{
                    'has-error':
                      configurationForm.get('assignTo').invalid &&
                      (configurationForm.get('assignTo').dirty ||
                        configurationForm.get('assignTo').touched ||
                        submitted)
                  }">
                <label for="assignTo" class="form-label asterisk-lbl">Assign to</label>
                <mat-form-field class="w-100">
                  <input type="text" matInput placeholder="Select or type user" formControlName="assignTo"
                    [matAutocomplete]="userAuto" (input)="onUserSearchInput($event)"
                    style="border: none !important; height: 22px; padding: 0px !important; font-size: 14px !important; font-family: 'Poppins', sans-serif !important; font-weight: 400 !important; color: #495057 !important;" />
                  <mat-autocomplete #userAuto="matAutocomplete" [displayWith]="displayUser"
                    (optionSelected)="onUserSelected($event.option.value)">
                    @for (user of filteredUsers; track user.id) {
                    <mat-option [value]="user">
                      {{ user.viewValue }}
                    </mat-option>
                    }
                    @if (filteredUsers.length === 0) {
                    <mat-option disabled>No users found</mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
                @if (
                configurationForm.get('assignTo').invalid &&
                (configurationForm.get('assignTo').dirty ||
                configurationForm.get('assignTo').touched || submitted)
                ) {
                <div class="validation-message">Please select to assign.</div>
                }
              </div>

              <!-- Is Windows Licensed -->
              <div class="form-group" [ngClass]="{
                    'has-error':
                      configurationForm.get('isLicensed').invalid &&
                      (configurationForm.get('isLicensed').dirty ||
                        configurationForm.get('isLicensed').touched ||
                        submitted)
                  }">
                <label class="labelish asterisk-lbl">Is Windows Licensed</label>
                <div class="rd-button">
                  <div class="d-flex align-items-center">
                    <input id="yes" type="radio" value="yes" formControlName="isLicensed" />
                    <label for="yes">Yes</label>
                  </div>

                  <div class="d-flex align-items-center">
                    <input id="no" type="radio" value="no" formControlName="isLicensed" />
                    <label for="no">No</label>
                  </div>
                </div>
                @if(configurationForm.get('isLicensed').invalid &&
                (configurationForm.get('isLicensed').dirty ||
                configurationForm.get('isLicensed').touched || submitted)){
                <div class="validation-message">Please select a type.</div>
                }
              </div>

              <!-- Product Key (HR-HEAD and ADMIN only) -->
              @if (canAccessProductKey) {
              <div class="form-group">
                <label for="productKey" class="form-label">Product Key</label>
                <input type="text" id="productKey" class="form-control" formControlName="productKey"
                  placeholder="Enter Product Key" />
              </div>
              }
            </div>

            <div class="d-flex justify-content-end align-items-center mt-5">
              <button type="submit" class="btn btn-warning">Next</button>
            </div>
          </form>
        </div>
      </div>
      }

      <!-- Accessories -->
      @if(currentStep === 2){
      <div class="accessories-container">
        <form [formGroup]="accessoriesForm" (ngSubmit)="onSubmitAccessories()">
          <div class="accessories-grid">
            <!-- Monitor 1 -->
            <div class="form-group" [ngClass]="{
                  'has-error':
                    accessoriesForm.get('monitor1').invalid &&
                    (accessoriesForm.get('monitor1').dirty ||
                      accessoriesForm.get('monitor1').touched ||
                      submitted)
                }">
              <label for="monitor1" class="form-label asterisk-lbl">Monitor 1</label>
              <input type="text" id="monitor1" class="form-control" formControlName="monitor1" />
              @if(accessoriesForm.get('monitor1').errors?.maxlength){
              <div style="color: red">
                Monitor name cannot exceed 50 characters.
              </div>
              }
            </div>

            <!-- Monitor 2 -->
            <div class="form-group" [ngClass]="{
                  'has-error':
                    accessoriesForm.get('monitor2').invalid &&
                    (accessoriesForm.get('monitor2').dirty ||
                      accessoriesForm.get('monitor2').touched ||
                      submitted)
                }">
              <label for="monitor2" class="form-label">Monitor 2</label>
              <input type="text" id="monitor2" class="form-control" formControlName="monitor2" />
              @if(accessoriesForm.get('monitor2').errors?.maxlength){
              <div style="color: red">
                Monitor name cannot exceed 50 characters.
              </div>
              }
            </div>

            <!-- Monitor 3 -->
            <div class="form-group" [ngClass]="{
                  'has-error':
                    accessoriesForm.get('monitor3').invalid &&
                    (accessoriesForm.get('monitor3').dirty ||
                      accessoriesForm.get('monitor3').touched ||
                      submitted)
                }">
              <label for="monitor3" class="form-label">Monitor 3</label>
              <input type="text" id="monitor3" class="form-control" formControlName="monitor3" />
              @if(accessoriesForm.get('monitor3').errors?.maxlength){
              <div style="color: red">
                Monitor name cannot exceed 50 characters.
              </div>
              }
            </div>

            <!-- Monitor 4 -->
            <div class="form-group">
              <label for="monitor4" class="form-label">Monitor 4</label>
              <input type="text" id="monitor4" class="form-control" formControlName="monitor4" />
              @if(accessoriesForm.get('monitor4').errors?.maxlength){
              <div style="color: red">
                Monitor name cannot exceed 50 characters.
              </div>
              }
            </div>

            <!-- Monitor 5 -->
            <div class="form-group">
              <label for="monitor5" class="form-label">Monitor 5</label>
              <input type="text" id="monitor5" class="form-control" formControlName="monitor5" />
              @if(accessoriesForm.get('monitor5').errors?.maxlength){
              <div style="color: red">
                Monitor name cannot exceed 50 characters.
              </div>
              }
            </div>

            <!-- Monitor 6 -->
            <div class="form-group">
              <label for="monitor6" class="form-label">Monitor 6</label>
              <input type="text" id="monitor6" class="form-control" formControlName="monitor6" />
              @if(accessoriesForm.get('monitor6').errors?.maxlength){
              <div style="color: red">
                Monitor name cannot exceed 50 characters.
              </div>
              }
            </div>

            <!-- Headphone -->
            <div class="form-group">
              <label for="headphone" class="form-label">Headphone</label>
              <input type="text" id="headphone" class="form-control" formControlName="headPhone" />
              @if(accessoriesForm.get('headPhone').errors?.maxlength){
              <div style="color: red">Cannot exceed 50 characters.</div>
              }
            </div>

            <!-- Keyboard -->
            <div class="form-group">
              <label for="keyboard" class="form-label">Keyboard</label>
              <input type="text" id="keyboard" class="form-control" formControlName="keyboard" />
              @if(accessoriesForm.get('keyboard').errors?.maxlength){
              <div style="color: red">Cannot exceed 50 characters.</div>
              }
            </div>

            <!-- Mouse -->
            <div class="form-group">
              <label for="mouse" class="form-label">Mouse</label>
              <input type="text" id="mouse" class="form-control" formControlName="mouse" />
              @if(accessoriesForm.get('mouse').errors?.maxlength){
              <div style="color: red">Cannot exceed 50 characters.</div>
              }
            </div>

            <!-- Camera -->
            <div class="form-group">
              <label for="camera" class="form-label">Camera</label>
              <input type="text" id="camera" class="form-control" formControlName="camera" />
              @if(accessoriesForm.get('camera').errors?.maxlength){
              <div style="color: red">Cannot exceed 50 characters.</div>
              }
            </div>

            <!-- Speakers -->
            <div class="form-group">
              <label for="speakers" class="form-label">Speakers</label>
              <input type="text" id="speakers" class="form-control" formControlName="speakers" />
              @if(accessoriesForm.get('speakers').errors?.maxlength){
              <div style="color: red">Cannot exceed 50 characters.</div>
              }
            </div>
          </div>

          <div class="d-flex justify-content-end align-items-center" style="margin-top: 24px;">
            @if (!isEdit) {
            <button type="submit" class="btn btn-warning d-flex align-items-center justify-content-center">
              Submit @if(isFormSubmitting){
              <div class="loader-circle" style="margin-left: 8px"></div>
              }
            </button>
            } @if (isEdit) {
            <button type="submit" class="btn btn-warning d-flex align-items-center justify-content-center">
              Update @if(isFormSubmitting){
              <div class="loader-circle" style="margin-left: 8px"></div>
              }
            </button>
            }
          </div>
        </form>
      </div>
      } @if(currentStep === 3){
      <div class="qr-creation-container">
        <div class="product-created-cont" style="padding-top: 50px">
          <svg class="tick-mark" width="76" height="76" viewBox="0 0 76 76" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M37.7808 3.91014C46.0698 3.91014 54.0763 6.92354 60.3083 12.3889C66.5404 17.8543 70.573 25.3989 71.655 33.617C72.7369 41.8352 70.7943 50.1664 66.1892 57.0586C61.584 63.9507 54.6303 68.9336 46.6237 71.079C38.6171 73.2244 30.1035 72.3858 22.6693 68.7197C15.2351 65.0535 9.38711 58.8097 6.21502 51.1516C3.04292 43.4935 2.76302 34.9434 5.42745 27.0942C8.09189 19.245 13.5189 12.6321 20.6975 8.48759"
              stroke="#24BA61" stroke-width="6.40622" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M24.9683 38.0768L33.5099 46.6184L50.5932 29.5352" stroke="#24BA61" stroke-width="5.33852"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          @if(!isEdit){
          <h3>Workstation Created!</h3>
          <p>Your Workstation has been successfully added.</p>
          } @if (isEdit) {
          <h3>Workstation Updated!</h3>
          <p>Your Workstation has been successfully Updated.</p>
          }
        </div>
        <div class="d-flex justify-content-center">
          <button style="color: #fff" class="btn btn-warning close" data-dismiss="modal" aria-label="Close">
            OK
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</div>
</div>

<!-- Preview Image Slider -->
@if (showPreviewModal) {
<div class="modal-backdrop fade show"></div>
<div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="imagePreviewModalTitle"
  aria-modal="true">
  <div class="modal-dialog modal-dialog-centered img-preview-width" role="document">
    <div class="modal-content img-preview-slider">
      <!-- Modal Header -->
      <div class="modal-header ws-slider-header">
        <button type="button" class="close inven-cls" (click)="closePreviewSlider()">
          <svg class="cross-svg" width="14" height="12" viewBox="0 0 14 14" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5518 1.64453L1.85612 12.3402" stroke="#25252B" stroke-width="2.26313" stroke-linecap="round" />
            <path d="M12.5518 12.3401L1.85612 1.64445" stroke="#25252B" stroke-width="2.26313" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <!-- Modal Body with carousel -->
      <div class="modal-body img-preview-container">
        <div class="d-flex justify-content-between">
          <div class="product-carousel2">
            <!-- Indicators -->
            @if (previewInventory?.images?.length > 1) {
            <ol class="carousel-indicators">
              @for (img of previewInventory.images; track img; let i = $index) {
              <li [class.active]="activeSlideIndex === i" (click)="goToSlide(i)"></li>
              }
            </ol>
            }

            <!-- Carousel inner -->
            <div class="carousel-inner">
              @for (productImg of previewInventory?.images; track productImg;
              let i = $index) {
              <div class="carousel-item" [ngClass]="{ active: activeSlideIndex === i }">
                <img [src]="
                    productImg ||
                    '../../../assets/inventories/default-inventory.png'
                  " class="d-block" alt="Inventory image" />
              </div>
              }
            </div>

            <!-- Prev/Next buttons -->
            @if (previewInventory?.images?.length > 1) {
            <button class="carousel-control-prev" type="button" (click)="prevSlide()">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </button>
            } @if (previewInventory?.images?.length > 1) {
            <button class="carousel-control-next" type="button" (click)="nextSlide()">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- Workstation Details -->
<div class="modal fade" id="workstationDetailModal" tabindex="-1" role="dialog"
  aria-labelledby="workstationDetailModalTitle" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered workstation-dtl-width" role="document">
    <div class="modal-content workstation-dtl-modal">
      <div class="modal-header d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          @if (activeDetailTab === 'history') {
          <button type="button"
            class="btn btn-sm btn-link back-btn mr-2 p-0 d-flex align-items-center text-decoration-none"
            (click)="activeDetailTab = 'details'" title="Back to Workstation Details">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
          </button>
          }
          <h5 class="modal-title m-0" id="workstationDetailModalLongTitle">
            Workstation Details
          </h5>
        </div>

        <div class="modal-header-actions">
          @if (canViewAssetLogs && activeDetailTab === 'details') {
          <button type="button" class="btn btn-sm btn-history-header mr-2" (click)="activeDetailTab = 'history'">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            Activity History
          </button>
          }
          <button type="button" class="close inven-cls m-0 p-0" data-dismiss="modal" aria-label="Close"
            (click)="activeDetailTab = 'details'">
            <svg class="cross-svg" width="14" height="12" viewBox="0 0 14 14" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5518 1.64453L1.85612 12.3402" stroke="#25252B" stroke-width="2.26313"
                stroke-linecap="round" />
              <path d="M12.5518 12.3401L1.85612 1.64445" stroke="#25252B" stroke-width="2.26313"
                stroke-linecap="round" />
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-body"
        [ngClass]="{'workstation-dtl-container': activeDetailTab === 'details', 'history-modal-body': activeDetailTab === 'history'}">
        @if (activeDetailTab === 'details') {
        <div class="prod-content d-flex justify-content-around">
          <div class="workst-image product-carousel">
            <div id="productImagecarousel" class="carousel slide" data-ride="carousel" data-interval="false">
              @if(previewProductImg?.images.length > 1){
              <ol class="carousel-indicators prod-indicators" style="bottom: -26% !important">
                <li data-target="#productImagecarousel" data-slide-to="0" class="active"></li>
                @for ( productImg of previewProductImg?.images.slice(1) ; track
                $index) {
                <li data-target="#productImagecarousel" data-slide-to="1" attr.data-slide-to="{{ $index }}"></li>
                }
              </ol>
              }
              <div class="carousel-inner">
                <div class="carousel-item product-dtl-img-slider active">
                  <img [src]="
                        previewProductImg?.images[0]
                          ? previewProductImg?.images[0]
                          : '../../../assets/inventories/computer-system.jpg'
                      " class="d-block" alt="..." />
                </div>
                @for ( productImg of previewProductImg?.images.slice(1) ; track
                $index) {
                <div class="carousel-item product-dtl-img-slider">
                  <img [src]="[productImg]" class="d-block" alt="..." />
                </div>

                }
              </div>
              @if(previewProductImg?.images.length > 1){
              <button class="carousel-control-prev product-prev" type="button" data-target="#productImagecarousel"
                data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </button>
              <button class="carousel-control-next product-next" type="button" data-target="#productImagecarousel"
                data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </button>
              }
            </div>
            <!-- <img [src]="workstationDetail?.image ? workstationDetail.image : '../../../assets/inventories/computer-system.jpg' " alt="" style="width:fit-content; height: 250px;" /> -->
          </div>
          <div class="workstation-content">
            <h2>{{ workstationDetail?.name }}</h2>
            @if(workstationDetail?.barcode){
            <img [src]="[workstationDetail?.barcode]" alt="barcode" width="220px"
              style="margin-left: 2px; margin-top: 10px; margin-bottom: 10px" />
            }
            @if (canAccessProductKey) {
            <div class="product-key-details-card">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <span class="product-key-label">Product Key</span>
                @if (workstationDetail?.productKey) {
                <div class="product-key-actions d-flex align-items-center">
                  <button type="button" class="btn btn-sm btn-link p-0 mr-2 text-decoration-none key-action-btn"
                    (click)="toggleProductKeyMask()"
                    [title]="isProductKeyMasked ? 'Show Product Key' : 'Hide Product Key'">
                    @if (isProductKeyMasked) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path
                        d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                      </path>
                      <line x1="1" y1="1" x2="23" y2="23"></line>
                    </svg>
                    }
                  </button>
                  <button type="button" class="btn btn-sm btn-link p-0 text-decoration-none key-action-btn"
                    (click)="copyProductKey(workstationDetail?.productKey)"
                    [title]="productKeyCopied ? 'Copied!' : 'Copy Product Key'">
                    @if (productKeyCopied) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="#24BA61" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                    }
                  </button>
                </div>
                }
              </div>
              <div class="product-key-value-wrapper">
                @if (workstationDetail?.productKey) {
                <code
                  class="product-key-code">{{ isProductKeyMasked ? '•••••-•••••-•••••-•••••' : workstationDetail.productKey }}</code>
                } @else {
                <span class="product-key-empty">—</span>
                }
              </div>
            </div>
            }
            @if(showWorkstationButton ){
            <div class="workstation-button d-flex align-items-center flex-wrap gap-2">
              <button type="edit" class="btn btn-primary" data-toggle="modal" data-target="#addWorkstationModal"
                data-dismiss="modal" aria-label="Close" (click)="editWorkstation()">
                <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                    <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path
                      d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
                  </g>
                </svg>
                Edit
              </button>
              <button type="archive" class="btn delete-workstation d-flex align-items-center justify-content-center"
                data-dismiss="modal" aria-label="Close" data-toggle="modal" data-target="#deleteProduct" (click)="
                    openDeleteModal()
                  ">
                <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M7.616 20q-.667 0-1.141-.475T6 18.386V6h-.5q-.213 0-.356-.144T5 5.499t.144-.356T5.5 5H9q0-.31.23-.54t.54-.23h4.46q.31 0 .54.23T15 5h3.5q.213 0 .356.144t.144.357t-.144.356T18.5 6H18v12.385q0 .666-.475 1.14t-1.14.475zm2.692-3q.213 0 .357-.144t.143-.356v-8q0-.213-.144-.356T10.307 8t-.356.144t-.143.356v8q0 .213.144.356q.144.144.356.144m3.385 0q.213 0 .356-.144t.143-.356v-8q0-.213-.144-.356Q13.904 8 13.692 8q-.213 0-.357.144t-.143.356v8q0 .213.144.356t.357.144" />
                </svg>
                Delete
              </button>
            </div>
            }
          </div>
        </div>
        } @else {
        <div class="history-modal-body-wrapper">
          <app-asset-history [isUnified]="false" assetType="Workstation"
            [assetId]="editWorkstationId || workstationDetail?._id" [assetName]="workstationDetail?.name"
            [assetCode]="workstationDetail?.workstationId">
          </app-asset-history>
        </div>
        }
      </div>
    </div>
  </div>
</div>
<!-- Delete Workstation Modal -->
@if(isDeleteModal){
<div class="modal fade" id="deleteProduct" tabindex="-1" role="dialog" aria-labelledby="deleteProductTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered delete-product-width" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close inven-cls" data-dismiss="modal" aria-label="Close">
          <svg class="cross-svg" width="14" height="12" viewBox="0 0 14 14" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5518 1.64453L1.85612 12.3402" stroke="#25252B" stroke-width="2.26313" stroke-linecap="round" />
            <path d="M12.5518 12.3401L1.85612 1.64445" stroke="#25252B" stroke-width="2.26313" stroke-linecap="round" />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="delete-container">
          <svg width="104" height="89" viewBox="0 0 104 89" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M97.9349 88.6895H5.81325C1.64318 88.6895 -0.953878 84.1499 1.17867 80.5605L47.2395 2.89153C49.3298 -0.624 54.4184 -0.624 56.5087 2.89153L102.569 80.5605C104.691 84.1499 102.105 88.6895 97.9349 88.6895Z"
              fill="#FDCC27" />
            <path
              d="M49.0954 60.7142L47.1602 31.8952C46.9876 29.2877 48.9591 27.0254 51.5666 26.8528C54.1741 26.6802 56.4364 28.6517 56.609 31.2592C56.6272 31.4682 56.6181 31.6953 56.609 31.8952L54.6557 60.7142C54.3286 64.1667 49.4225 64.1667 49.0954 60.7142Z"
              fill="#030303" />
            <path
              d="M51.8757 75.0512C54.0083 75.0512 55.737 73.3225 55.737 71.1899C55.737 69.0574 54.0083 67.3286 51.8757 67.3286C49.7432 67.3286 48.0144 69.0574 48.0144 71.1899C48.0144 73.3225 49.7432 75.0512 51.8757 75.0512Z"
              fill="#030303" />
          </svg>
          <h3>Delete Product?</h3>
          <p>Are you sure you want to permanently delete the product?</p>
        </div>
        <div class="delete-button d-flex justify-content-center">
          <button type="delete" class="btn btn-danger" style="margin-right: 20px; width: 215px"
            (click)="deleteWorkstation(editWorkstationId)">
            Delete
          </button>
          <button type="archive" class="close btn goback-btn" data-dismiss="modal" aria-label="Close">
            Go Back
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- Unified Workstation Logs Modal -->
@if (canViewAssetLogs) {
<div class="modal fade" id="unifiedWorkstationLogsModal" tabindex="-1" role="dialog"
  aria-labelledby="unifiedWorkstationLogsModalTitle" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered workstation-dtl-width" role="document">
    <div class="modal-content workstation-dtl-modal">
      <div class="modal-header d-flex justify-content-between align-items-center">
        <h5 class="modal-title m-0" id="unifiedWorkstationLogsModalTitle">
          Unified Workstation Logs
        </h5>
        <div class="modal-header-actions">
          <button type="button" class="close inven-cls m-0 p-0" data-dismiss="modal" aria-label="Close">
            <svg class="cross-svg" width="14" height="12" viewBox="0 0 14 14" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5518 1.64453L1.85612 12.3402" stroke="#25252B" stroke-width="2.26313"
                stroke-linecap="round" />
              <path d="M12.5518 12.3401L1.85612 1.64445" stroke="#25252B" stroke-width="2.26313"
                stroke-linecap="round" />
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-body history-modal-body">
        <div class="history-modal-body-wrapper">
          <app-asset-history [isUnified]="true" assetType="All">
          </app-asset-history>
        </div>
      </div>
    </div>
  </div>
</div>
}